import styled from 'styled-components';
export const Icon = styled.svg `
  height: 2rem;
  width: 2rem;
  margin-right: 1rem;

  use {
    fill:#24195F;
  }
`;
export const Title = styled.span `
  text-align: left;
  margin-right: 1rem;
`;
export const Chevron = styled.svg `
  height: 1.2rem;
  width: 1.2rem;
  transform: rotate(180deg);
  margin-left: auto;
  position: relative;
  top: 0;
  
  use {
    fill: var(--primary-medium);
  }
`;
export const Element = styled.button `
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  text-decoration: none;
  font: var(--heading-five-font);
  color: var(--primary-darker);
  width: 100%;
  padding: 0;
  cursor: pointer;
`;
export default {
    Chevron,
    Element,
    Icon,
    Title,
};
